import React, { useEffect, useState } from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import {
  Modal,
  Table,
  Form,
  Input,
  Row,
  Col,
  Popconfirm,
  Select,
  Upload,
  Checkbox,
  Typography,
  InputNumber,
  Card,
  Divider,
  TreeSelect,
  DatePicker,
  Spin,
  Drawer,
} from "antd";
import { errorHandle, openNotificationWithIcon, toSlug } from "../../Function";
import moment from "moment";
import { Link } from "react-router-dom";
import {
  PlusCircleOutlined,
  DownloadOutlined,
  UploadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  AuditOutlined,
  LockOutlined,
  UnlockOutlined,
  DoubleRightOutlined,
  RedoOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import ListTeamApi from "../../../api/getListTeam";
import {
  DownloadStaffApi,
  DownloadTempStaffApi,
  UploadTempStaffApi,
} from "../../../api/getInfoData";
import {
  GetChucVuApi,
  GetListGroupRoleApi,
  GetListRoleApi,
  GetListUserApi,
  GetLoaiNVApi,
  GetLoaiUserApi,
  GetPhuongThucCCApi,
  GetUserEditApi,
  PostUserApi,
  PutRoleUserApi,
  PutUserApi,
  ResetPassrApi,
} from "../../../api/usersApi";
import { useSelector } from "react-redux";

const { Text } = Typography;
const { Search } = Input;

const validateMessages = {
  required: "${label} là bắt buộc.",
  types: {
    email: "${label} không đúng định dạng.",
    number: "${label} không đúng định dạng.",
  },
  number: {
    range: "${label} phải từ ${min} đến ${max}",
  },
};

function disabledDate(current) {
  // Can not select days before today and today
  const currentDate = new Date();
  return current && current > moment().endOf("day");
  // return current && current < moment(new Date(currentDate.getFullYear(),currentDate.getMonth()-1),0).add(-1,'days').endOf('day');
}

const ModalAddStaff = ({
  visible,
  onCancel,
  fetchData,
  search,
  pager,
  currentDate,
  lsTeam,
  lsChucVu,
  lsLoaiND,
  lsLoaiNhanVien,
  lsLoaiCC,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, []);

  const onFinish = (values) => {
    PostUserApi({
      username: values.username,
      ten: values.ten,
      ho: values.ho,
      email: values.email,
      team: values.team,
      chucVu: values.chucVu,
      loaiND: values.loaiND,
      loaiNV: values.loaiNV,
      loaiCC: values.loaiCC,
      msnv: values.msnv,
      phepNam: values.phepNam || 0,

      ngay_sinh:
        values.ngay_sinh != undefined
          ? moment(values.ngay_sinh).format("YYYY-MM-DD")
          : null,
      ngaycap:
        values.ngaycap != undefined
          ? moment(values.ngaycap).format("YYYY-MM-DD")
          : null,
      cmnd_cccd: values.cmnd_cccd,
      ngayvao:
        values.ngayvao != undefined
          ? moment(values.ngayvao).format("YYYY-MM-DD")
          : null,
      sdt: values.sdt,
    })
      .then((res) => {
        if (res.data.error) {
          openNotificationWithIcon("error", res.data.error);
        } else {
          fetchData({ page: pager.current, page_size: pager.pageSize, search });
          onCancel();
          form.resetFields();
        }
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onCloseModal = () => {
    form.resetFields();
    onCancel();
  };

  // const handleBlur = (Object) => {
  //     let valueTemp = Object.target.value;

  //     if (Object.target.value.charAt(Object.target.value.length - 1) === '.' || Object.target.value === '-') {
  //       valueTemp = Object.target.value.slice(0, -1);
  //     }
  //     console.log(valueTemp);
  //     console.log(valueTemp.replace(/.*(\d+)/, '$2'));
  //     form.setFieldsValue({
  //         soDT: valueTemp.replace(/0*(\d+)/, '$1'),

  //     })
  // };

  const onChangeFields = (event, field, intChoose) => {
    let valueTemp = event.target.value;
    switch (intChoose) {
      case 1:
        // console.log(1);
        if (
          event.target.value.charAt(event.target.value.length - 1) === "." ||
          event.target.value === "-"
        ) {
          valueTemp = event.target.value.slice(0, -1);
        }
        let newValue = toSlug(event.target.value);
        form.setFieldsValue({
          [field]: newValue,
          // username: valueTemp.replace(/\s+/, ''),
        });
        break;
      case 2:
        break;
      default:
      // code block
    }
  };

  const styleFormItem = {
    marginBottom: "12px",
  };

  const fileDownload_TempStaff = () => {
    const fnFileDownload = require("js-file-download");
    const filename = "Danh sach user.xlsx";
    DownloadTempStaffApi().then((res) => {
      fnFileDownload(res.data, filename);
    });
  };

  return (
    <Modal
      title={
        <Row>
          <Col span={18}>Thêm nhân viên</Col>
          <Col span={5}>
            <Button
              type="link"
              onClick={fileDownload_TempStaff}
              icon={<DownloadOutlined />}
              style={{ float: "right" }}
              size="middle"
            >
              File mẫu
            </Button>
          </Col>
        </Row>
      }
      visible={visible}
      onCancel={onCloseModal}
      footer={false}
      width={800}
    >
      <Form
        form={form}
        name="basic"
        layout={"vertical"}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        validateMessages={validateMessages}
      // size="small"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Tên đăng nhập"
              name="username"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              {/* <Input maxLength={100}  onChange={(e) => { onChangeFields(e, 'username', 1); }} defaultValue={<span>Chi tiết công - {form.getFieldValue('username')}</span>}/> */}
              <Input
                maxLength={100}
                onChange={(e) => {
                  onChangeFields(e, "username", 1);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Team"
              name="team"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {lsTeam.map((item, index) => (
                  <Select.Option key={index} value={item.id}>
                    {item.tenTeam}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Tên"
              name="ten"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Input
                maxLength={100}
                onBlur={(e) => {
                  form.setFieldsValue({ ten: e.target.value.trim() });
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Chức vụ"
              name="chucVu"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="children">
                {lsChucVu.map((item, index) => (
                  <Select.Option key={item.ten_cv} value={item.id}>
                    {item.ten_cv}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12} hidden>
            <Form.Item
              label="Họ"
              name="ho"
              // hidden={true}
              // rules={[{ required: true}]}
              style={styleFormItem}
            >
              <Input
                maxLength={100}
                onBlur={(e) => {
                  form.setFieldsValue({ ho: e.target.value.trim() });
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, type: "email" }]}
              style={styleFormItem}
            >
              <Input
                maxLength={100}
                onBlur={(e) => {
                  form.setFieldsValue({ email: e.target.value.trim() });
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Loại người dùng"
              name="loaiND"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Select allowClear>
                {lsLoaiND.map((item, index) => (
                  <Select.Option key={item.ten_loai} value={item.id}>
                    {item.ten_loai}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Mã số nhân viên"
              name="msnv"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Input
                maxLength={15}
                pattern="[0-9]*"
                title="Chỉ nhập ký tự từ 0 đến 9"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Loại nhân viên"
              name="loaiNV"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Select allowClear>
                {lsLoaiNhanVien.map((item, index) => (
                  <Select.Option key={item.ten_loainv} value={item.id}>
                    {item.ten_loainv}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Phép năm"
              name="phepNam"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <InputNumber
                min={0}
                max={12}
                maxLength={2}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Loại chấm công"
              name="loaiCC"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Select allowClear>
                {lsLoaiCC.map((item, index) => (
                  <Select.Option key={item.ten_ptcc} value={item.id}>
                    {item.ten_ptcc}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Ngày cấp" name="ngaycap" style={styleFormItem}>
              <DatePicker
                format={"DD/MM/YYYY"}
                disabledDate={disabledDate}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="CMND/CCCD" name="cmnd_cccd" style={styleFormItem}>
              <Input style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Ngày sinh" name="ngay_sinh" style={styleFormItem}>
              <DatePicker
                format={"DD/MM/YYYY"}
                disabledDate={disabledDate}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="SĐT" name="sdt" style={styleFormItem}>
              <Input
                maxLength={12}
                style={{ width: "100%" }}
                pattern="[0-9]*"
                title="Chỉ nhập ký tự từ 0 đến 9"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Ngày vào" name="ngayvao" style={styleFormItem}>
              <DatePicker
                format={"DD/MM/YYYY"}
                disabledDate={disabledDate}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item wrapperCol={{ offset: 10, span: 12 }}>
          <Button type="success" htmlType="submit" className={"m-2"}>
            Thêm
          </Button>
          <Button onClick={onCloseModal}>Thoát</Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const ModalEditStaff = ({
  visible,
  onCancel,
  fetchData,
  search,
  pager,
  currentDate,
  lsTeam,
  dataInforUser,
  lsChucVu,
  lsLoaiND,
  lsLoaiNhanVien,
  lsLoaiCC,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
    if (visible) {
      form.setFieldsValue({
        username: dataInforUser.username,
        team:
          lsTeam.filter((item) => item.id == dataInforUser.fore_team).length !=
            0
            ? dataInforUser.fore_team
            : "",
        ten:
          dataInforUser.last_name != ""
            ? dataInforUser.last_name + " " + dataInforUser.first_name
            : dataInforUser.first_name,
        chucVu: dataInforUser.fore_chucvu,
        // ho: dataInforUser.last_name,
        loaiND: dataInforUser.fore_loaiuser,
        loaiNV: dataInforUser.fore_loai_nv,
        loaiCC: dataInforUser.fore_phuongthuc_cc,
        msnv: dataInforUser.msnv,
        email: dataInforUser.email,
        ngay_sinh:
          dataInforUser.ngay_sinh != null
            ? moment(dataInforUser.ngay_sinh, "YYYY/MM/DD")
            : "",
      });
      if (dataInforUser.detailUser.length != 0) {
        form.setFieldsValue({
          cmnd_cccd: dataInforUser.detailUser[0].cmnd_cccd || "",
          ngayvao:
            dataInforUser.detailUser[0].ngayvao != null
              ? moment(dataInforUser.detailUser[0].ngayvao, "YYYY/MM/DD")
              : "",
          ngaycap:
            dataInforUser.detailUser[0].ngaycap != null
              ? moment(dataInforUser.detailUser[0].ngaycap, "YYYY/MM/DD")
              : "",
          sdt:
            dataInforUser.detailUser[0].sdt != null
              ? dataInforUser.detailUser[0].sdt
              : "",
        });
      }
    }
  }, [visible]);

  const onFinish = (values) => {
    PutUserApi({
      userId: dataInforUser.id,
      username: values.username,
      ten: values.ten,
      ho: values.ho == undefined ? "" : values.ho,
      email: values.email,
      team: values.team,
      chucVu: values.chucVu,
      loaiND: values.loaiND,
      loaiNV: values.loaiNV,
      loaiCC: values.loaiCC,
      phepNam: values.phepNam || 0,
      block: false,
      ngay_sinh:
        values.ngay_sinh != undefined
          ? moment(values.ngay_sinh).format("YYYY-MM-DD")
          : null,
      ngaycap:
        values.ngaycap != undefined
          ? moment(values.ngaycap).format("YYYY-MM-DD")
          : null,
      cmnd_cccd: values.cmnd_cccd != undefined ? values.cmnd_cccd : null,
      ngayvao:
        values.ngayvao != undefined
          ? moment(values.ngayvao).format("YYYY-MM-DD")
          : null,
      sdt: values.sdt != undefined ? values.sdt : null,
    })
      .then((res) => {
        if (res.data.error) {
          openNotificationWithIcon("error", res.data.error);
        } else {
          fetchData({ page: pager.current, page_size: pager.pageSize, search });
          onCancel();
          form.resetFields();
        }
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const styleFormItem = {
    marginBottom: "12px",
  };

  return (
    <Modal
      title={"Chỉnh sửa thông tin nhân viên"}
      visible={visible}
      onCancel={onCancel}
      footer={false}
      width={800}
    >
      <Form
        form={form}
        name="basic"
        // labelCol={{ span: 5 }}
        // wrapperCol={{span: 14, offset: 4}}
        layout={"vertical"}
        // initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        validateMessages={validateMessages}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Tên đăng nhập"
              name="username"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Input maxLength={100} disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Team"
              name="team"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {lsTeam.map((item, index) => (
                  <Select.Option key={index} value={item.id}>
                    {item.tenTeam}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Tên"
              name="ten"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Chức vụ"
              name="chucVu"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {lsChucVu.map((item, index) => (
                  <Select.Option key={item.ten_cv} value={item.id}>
                    {item.ten_cv}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12} hidden>
            <Form.Item
              label="Họ"
              name="ho"
              // hidden={true}
              // rules={[{ required: true}]}
              style={styleFormItem}
            >
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Loại người dùng"
              name="loaiND"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Select allowClear>
                {lsLoaiND.map((item, index) => (
                  <Select.Option key={item.ten_loai} value={item.id}>
                    {item.ten_loai}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Mã số nhân viên"
              name="msnv"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Input maxLength={100} disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Loại nhân viên"
              name="loaiNV"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Select allowClear>
                {lsLoaiNhanVien.map((item, index) => (
                  <Select.Option key={item.ten_loainv} value={item.id}>
                    {item.ten_loainv}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="SĐT" name="sdt" style={styleFormItem}>
              <Input
                maxLength={12}
                style={{ width: "100%" }}
                pattern="[0-9]*"
                title="Chỉ nhập ký tự từ 0 đến 9"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Loại chấm công"
              name="loaiCC"
              rules={[{ required: true }]}
              style={styleFormItem}
            >
              <Select allowClear>
                {lsLoaiCC.map((item, index) => (
                  <Select.Option key={item.ten_ptcc} value={item.id}>
                    {item.ten_ptcc}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Ngày cấp" name="ngaycap" style={styleFormItem}>
              <DatePicker
                format={"DD/MM/YYYY"}
                disabledDate={disabledDate}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="CMND/CCCD" name="cmnd_cccd" style={styleFormItem}>
              <Input style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Ngày sinh" name="ngay_sinh" style={styleFormItem}>
              <DatePicker
                format={"DD/MM/YYYY"}
                disabledDate={disabledDate}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Ngày vào" name="ngayvao" style={styleFormItem}>
              <DatePicker
                format={"DD/MM/YYYY"}
                disabledDate={disabledDate}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col offset={9}>
            <Form.Item>
              <Button type="success" htmlType="submit" className={"m-2"}>
                Thêm
              </Button>
              <Button onClick={onCancel}>Thoát</Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const ModalRoleUser = ({
  visible,
  onCancel,
  fetchData,
  search,
  pager,
  currentDate,
  lsTeam,
  dataInforUser,
  lsQuyen,
  lsGroupRole,
}) => {
  const [form] = Form.useForm();
  const [lsGroupUpdate, setLsGroupUpdate] = useState([]);
  const [lsRoleUpdate, setLsRoleUpdate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading_NQ, setLoading_NQ] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const showDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);

  useEffect(() => {
    // console.log(lsTeam);
    form.resetFields();
    if (visible) {
      form.setFieldsValue({
        username: dataInforUser.username,
      });

      let newLsGroupUp = lsGroupUpdate;
      for (let value of dataInforUser.nhomQuyenUser) {
        form.setFieldsValue({
          ["ckbNQ" + value]: true,
        });
        newLsGroupUp = [...newLsGroupUp, value];
      }
      setLsGroupUpdate(newLsGroupUp);

      const arrTeam = dataInforUser.team_permissions.map((item, index) => {
        return item.phanquyen__ten_pq;
      });
      const uniqueArrTeam = [
        ...dataInforUser.user_permissions,
        ...new Set(arrTeam),
      ];

      let newLsRoleUp = lsRoleUpdate;
      for (let value of lsQuyen) {
        if (uniqueArrTeam.includes(value.ten_pq)) {
          form.setFieldsValue({
            ["ckbRole" + value.id]: true,
          });
          if (value.requiredTeam) {
            form.setFieldsValue({
              ["lsTeam-" + value.id]: dataInforUser.team_permissions
                .filter((item) => item.phanquyen__ten_pq == value.ten_pq)
                .map((item, index) => item.team),
            });
          }
          newLsRoleUp = [...newLsRoleUp, value.id];
        }
      }
      setLsRoleUpdate(newLsRoleUp);
    }
  }, [visible]);

  const onFinish = (values) => {
    setLoading(true);
    setLoading_NQ(true);
    const lsTeam = {};
    for (let val of lsRoleUpdate) {
      lsTeam[val] =
        values["lsTeam-" + val] === undefined ? [] : values["lsTeam-" + val];
    }
    // console.log(values);
    // console.log(lsGroupUpdate);
    // console.log(lsRoleUpdate);
    // console.log(lsTeam);

    PutRoleUserApi({
      userId: dataInforUser.id,
      lsGroupRole: lsGroupUpdate,
      listRole: lsTeam,
    })
      .then((res) => {
        if (res.data.error) {
          openNotificationWithIcon("error", res.data.error);
        } else {
          fetchData({ page: pager.current, page_size: pager.pageSize, search });
          onCancelModal();
        }
        setLoading(false);
        setLoading_NQ(false);
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
        setLoading(false);
        setLoading_NQ(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onCancelModal = () => {
    form.resetFields();
    setLsGroupUpdate([]);
    setLsRoleUpdate([]);
    // fetchData()
    onCancel();
  };

  const onChangeRoleWithGroup = (idGroupRole, checked) => {
    setLoading(true);
    console.log(lsGroupRole);

    let listPermissionInGroup = lsGroupRole.filter(
      (item) => item.id === idGroupRole
    )[0].permission_in_group;
    let newLsRoleUp = lsRoleUpdate;
    lsQuyen.map((itemRole, indexRole) => {
      if (listPermissionInGroup.includes(itemRole.id)) {
        form.setFieldsValue({
          ["ckbRole" + itemRole.id]: checked,
        });
        if (checked) {
          newLsRoleUp = [...new Set([...newLsRoleUp, itemRole.id])];
          // form.setFieldsValue({
          //     ["lsTeam-"+ itemRole.id]: []
          // });
        } else {
          newLsRoleUp = newLsRoleUp.filter((item) => item !== itemRole.id);
          // form.resetFields(["lsTeam-"+ itemRole.id])
        }
      }
    });
    setLsRoleUpdate([...new Set(newLsRoleUp)]);
    setLoading(false);
  };

  const onChangeRoleAll = (checked) => {
    setLoading(true);
    lsGroupRole.forEach((element) => {
      form.setFieldsValue({
        ["ckbNQ" + element.id]: checked,
      });
    });
    lsQuyen.map((itemRole, indexRole) => {
      form.setFieldsValue({
        ["ckbRole" + itemRole.id]: checked,
        // ["lsTeam-"+ itemRole.id]: []
      });
    });
    if (checked) {
      setLsRoleUpdate(lsQuyen.map((itemRole, indexRole) => itemRole.id));
      setLsGroupUpdate(lsGroupRole.map((itemGr, indexGr) => itemGr.id));
    } else {
      form.resetFields();
      setLsRoleUpdate([]);
      setLsGroupUpdate([]);
    }
    setLoading(false);
  };

  // const handleSelectAll = (value) => {
  //     if (value && value.length && value.includes("all")) {
  //         if (value.length === all.length + 1) {
  //             return [];
  //         }
  //         return [...all];
  //     }
  //     return value;
  // }
  const TreeSelectTeam = ({ idRole }) => {
    // console.log(form.getFieldValue(`lsTeam-` + idRole));
    // Nếu dùng useState và gọi lại nó ngay lập tức, buộc React phải gọi lại hàm 1 lần nữa cùng 1 thành phần
    // sẽ gặp lỗi Uncaught Error: Too many re-renders.
    const [selectedValues, setSelectedValues] = useState(
      form.getFieldValue(`lsTeam-` + idRole)
        ? form.getFieldValue(`lsTeam-` + idRole)
        : []
    );
    // if (form.getFieldValue(`lsTeam-` + idRole)) {
    //     setSelectedValues(form.getFieldValue(`lsTeam-` + idRole));
    // }

    return (
      <TreeSelect
        treeNodeFilterProp="title" // search theo value (ko phải id)
        allowClear={true}
        placeholder="Chọn team"
        treeCheckable={true}
        showCheckedStrategy={TreeSelect.SHOW_CHILD}
        style={{ width: "fit-content", minWidth: 200 }}
        // dropdownStyle={{ maxHeight: "300px" }}
        onChange={(ids) => {
          setSelectedValues(ids);
          form.setFieldsValue({ [`lsTeam-` + idRole]: ids });
        }}
        value={selectedValues}
        maxTagCount={1}
        // maxTagPlaceholder={omittedValues =>
        //   `+ ${omittedValues.length} Blocks ...`
        // }
        treeData={[
          {
            title:
              selectedValues.length > 0 ? (
                <span
                  onClick={() => {
                    setSelectedValues([]);
                    form.setFieldsValue({ [`lsTeam-` + idRole]: [] });
                  }}
                  style={{
                    display: "inline-block",
                    color: "#286FBE",
                    cursor: "pointer",
                  }}
                >
                  Bỏ chọn tất cả
                </span>
              ) : (
                <span
                  onClick={() => {
                    setSelectedValues(lsTeam.map((item) => item.id));
                    form.setFieldsValue({
                      [`lsTeam-` + idRole]: lsTeam.map((item) => item.id),
                    });
                  }}
                  style={{
                    display: "inline-block",
                    color: "#286FBE",
                    cursor: "pointer",
                  }}
                >
                  Chọn tất cả
                </span>
              ),
            value: "xxx",
            disableCheckbox: true,
            disabled: true,
          },
          ...lsTeam.map((item) => {
            return { title: item.tenTeam, value: item.id, key: item.id };
          }),
        ]}
      />
    );
  };

  return (
    <Modal
      title={
        <div
          style={{
            // display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Phân quyền người dùng</span>
          <Button
            type="link"
            icon={<QuestionCircleOutlined />}
            onClick={() => showDrawer()}
            style={{
              float: "right",
              marginRight: "25px",
              paddingBottom: "20px",
            }}
          ></Button>
        </div>
      }
      open={visible}
      onCancel={onCancelModal}
      footer={false}
      width={800}
      className={"site-drawer-render-in-current-wrapper"}
      confirmLoading={loading}
      maskClosable={false} // Tắt click ra ngoài để đóng
    >
      <Form
        form={form}
        name="basic"
        // layout={"vertical"}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        validateMessages={validateMessages}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Tên người dùng" name="username">
              <Text strong>{dataInforUser.username}</Text>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <Card
              title="Nhóm quyền"
              bordered={false}
              style={{ height: 500 }}
              extra={<DoubleRightOutlined style={{ fontSize: "16px" }} />}
              headStyle={{ padding: "0px 6px" }}
              bodyStyle={{ padding: "6px" }}
              loading={loading_NQ}
            >
              {lsGroupRole.map((itemNQ, indexNQ) => (
                <Form.Item
                  name={"ckbNQ" + itemNQ.id}
                  label=""
                  valuePropName={"checked"}
                >
                  <Checkbox
                    onChange={(e) => {
                      if (e.target.checked === false) {
                        setLsGroupUpdate(
                          lsGroupUpdate.filter((item) => item !== itemNQ.id)
                        );
                      } else {
                        setLsGroupUpdate([
                          ...new Set([...lsGroupUpdate, itemNQ.id]),
                        ]);
                      }
                      form.setFieldsValue({
                        ["ckbNQ" + itemNQ.id]: e.target.checked,
                      });
                      onChangeRoleWithGroup(itemNQ.id, e.target.checked);
                    }}
                  >
                    {itemNQ.ten_groups}
                  </Checkbox>
                </Form.Item>
              ))}
              <Form.Item
                name={"ckbRoleALL"}
                label=""
                valuePropName={"checked"}
                style={{ marginBottom: "0px" }}
              >
                <Checkbox
                  onChange={(e) => {
                    form.setFieldsValue({
                      ["ckbRoleALL"]: e.target.checked,
                    });
                    onChangeRoleAll(e.target.checked);
                  }}
                >
                  Tất cả
                </Checkbox>
              </Form.Item>
            </Card>
          </Col>
          <Col span={18}>
            <Card
              title="Chi tiết quyền"
              bordered={false}
              bodyStyle={{ height: 430, overflowX: "auto", padding: "6px" }}
              loading={loading}
            >
              {lsQuyen.map((itemRole, indexRole) => (
                <>
                  <Row>
                    <Col span={17}>
                      <Form.Item
                        name={"ckbRole" + itemRole.id}
                        label=""
                        valuePropName={"checked"}
                        style={{ marginBottom: "0px" }}
                      >
                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked === false) {
                              setLsRoleUpdate(
                                lsRoleUpdate.filter(
                                  (item) => item !== itemRole.id
                                )
                              );
                            } else {
                              setLsRoleUpdate([
                                ...new Set([...lsRoleUpdate, itemRole.id]),
                              ]);
                            }
                            form.setFieldsValue({
                              ["ckbRole" + itemRole.id]: e.target.checked,
                              ["lsTeam-" + itemRole.id]: [],
                            });
                          }}
                        >
                          {itemRole.mota}
                        </Checkbox>
                      </Form.Item>
                    </Col>
                    <Col span={7}>
                      <Form.Item
                        noStyle
                        shouldUpdate={(prevValues, currentValues) =>
                          prevValues["ckbRole" + itemRole.id] !==
                          currentValues["ckbRole" + itemRole.id]
                        }
                      >
                        {({ getFieldValue }) => {
                          return getFieldValue("ckbRole" + itemRole.id) ===
                            true && itemRole.requiredTeam === true ? (
                            <Form.Item
                              name={`lsTeam-` + itemRole.id}
                              label=""
                              style={{ marginBottom: "0px" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Yêu cầu chọn team",
                                },
                              ]}
                            >
                              <TreeSelectTeam idRole={itemRole.id} />

                              {/* <Select
                                                            mode={'multiple'}
                                                            allowClear={false}
                                                            style={{width: '100%'}}
                                                            placeholder="Chọn team"
                                                            maxTagCount={1}
                                                        >
                                                            {lsTeam.map((item,index) => (
                                                                <Select.Option key={index} value={item.id}>{item.tenTeam}</Select.Option>
                                                            ))}
                                                        </Select> */}
                            </Form.Item>
                          ) : null;
                        }}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Divider
                    style={{
                      borderTop: "0.1px solid rgb(230 230 230)",
                      margin: "9px 0px",
                    }}
                  ></Divider>
                </>
              ))}
            </Card>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col offset={9}>
            <Form.Item>
              <Button
                type="success"
                htmlType="submit"
                className={"m-2"}
                disabled={loading}
              >
                Thêm
              </Button>
              <Button onClick={onCancelModal}>Thoát</Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Drawer
        title="Lưu ý sử dụng"
        placement="right"
        onClose={closeDrawer}
        open={isDrawerOpen}
        width={450}
        keyboard
        getContainer={false}
      >
        <p>
          <strong>1. Chi tiết phân quyền</strong>
        </p>
        <ul>
          <li>
            Phần quyền [Quản lý - Đề nghị chấm công - Hủy duyệt] chỉ sử dụng cho nhân viên thuộc bộ phận nhân sự.
            Có quyền xóa chấm công mà nhân viên đề nghị - trạng thái không duyệt (Chỉ áp dụng cho trường hợp chưa chốt công của nhân viên trong tháng đề nghị).
          </li>
        </ul>
      </Drawer>
    </Modal>
  );
};

export const DanhSachNhanVien = () => {
  const defaultPageSize = 10;
  const [pager, setPager] = useState({
    pageSize: defaultPageSize,
    count: 0,
    current: 1,
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [isShowAddStaff, setIsShowAddStaff] = useState(false);
  const [currentSelectedDate, setCurrentSelectedDate] = useState(
    moment(new Date())
  );
  const [lsTeam, setLsTeam] = useState([]);
  const [lsChucVu, setLsChucVu] = useState([]);
  const [lsLoaiND, setLsLoaiND] = useState([]);
  const [lsLoaiNhanVien, setLsLoaiNhanVien] = useState([]);
  const [lsLoaiCC, setLsLoaiCC] = useState([]);
  const [lsQuyen, setLsQuyen] = useState([]);
  const [lsGroupRole, setLsGroupRole] = useState([]);
  const [fileExcelUpload, setFileExcelUpload] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [isShowEditStaff, setIsShowEditStaff] = useState(false);
  const [dataInforUser, setDataInforUser] = useState([]);
  const [isShowRole, setIsShowRole] = useState(false);
  const [fileExcelDataStaff, setFileExcelDataStaff] = useState([]);
  const [loading_page, setLoading_page] = useState(false);
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);

  const fetchData = (params = {}) => {
    setLoading(true);
    GetListUserApi(params)
      .then((res) => {
        setData(res.data.results);
        setPager({
          current: params.page,
          pageSize: params.page_size,
          count: res.data.count,
        });
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  const fetchListTeam = () => {
    ListTeamApi().then((res) => {
      setLsTeam(res.data);
    });
  };

  const fetchListChucVu = () => {
    GetChucVuApi().then((res) => {
      setLsChucVu(res.data);
    });
  };

  const fetchListLoaiND = () => {
    GetLoaiUserApi().then((res) => {
      setLsLoaiND(res.data);
    });
  };

  const fetchListLoaiNhanVien = () => {
    GetLoaiNVApi().then((res) => {
      setLsLoaiNhanVien(res.data);
    });
  };

  const fetchListLoaiCC = () => {
    GetPhuongThucCCApi().then((res) => {
      setLsLoaiCC(res.data);
    });
  };

  const fetchListRole = () => {
    GetListRoleApi().then((res) => {
      setLsQuyen(res.data);
    });
  };

  const fetchListGrouptRole = () => {
    GetListGroupRoleApi().then((res) => {
      // console.log(res.data);
      setLsGroupRole(res.data);
    });
  };

  useEffect(() => {
    // fetchData({page:pager.current,page_size:pager.pageSize,search});
    fetchListTeam();
    fetchListChucVu();
    fetchListLoaiND();
    fetchListLoaiNhanVien();
    fetchListLoaiCC();
    fetchListRole();
    fetchListGrouptRole();
  }, []);

  const onLock_Unlock = (record) => {
    PutUserApi({
      userId: record.id,
      block: "true",
      isActive: !record.isActive,
    })
      .then((r) => {
        fetchData({ page: pager.current, page_size: pager.pageSize, search });
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const onShowModalEdit = (record) => {
    GetUserEditApi(record.id)
      .then((re) => {
        setDataInforUser(re.data);
        setIsShowEditStaff(true);
      })
      .catch((err) => {
        if (err.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const onShowModalRole = (record) => {
    GetUserEditApi(record.id)
      .then((re) => {
        // console.log(re.data);
        setDataInforUser(re.data);
        setIsShowRole(true);
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const resetPass = (idUser) => {
    ResetPassrApi({ user_id: idUser })
      .then((r) => {
        openNotificationWithIcon(
          "success",
          "Thành công",
          "Khôi phục mật khẩu thành công, mật khẩu mặc định là Rsvn@12345"
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getButtonChangeStatus = (record) => {
    // console.log(record.status);
    return (
      <>
        <Row>
          <Col span={8}>
            <span
              title="Chỉnh sửa"
              className={"col-6"}
              style={{ color: "#4290d3", cursor: "pointer" }}
              onClick={() => onShowModalEdit(record)}
            >
              <EditOutlined />
            </span>
          </Col>
          <Col span={8}>
            <span
              title="Phân quyền user"
              className={"col-6"}
              style={{ color: "#876506", cursor: "pointer" }}
              onClick={() => onShowModalRole(record)}
            >
              <AuditOutlined />
            </span>
          </Col>
          <Col span={8}>
            {record.isActive === true ? (
              <span
                title={"Khóa user"}
                className={"col-6"}
                style={{ color: "red", cursor: "pointer" }}
              >
                <Popconfirm
                  title="Xác nhận khóa user"
                  onConfirm={() => onLock_Unlock(record)}
                  okText="Khóa"
                >
                  <LockOutlined style={{ color: "#ff4d4f" }} />
                </Popconfirm>
              </span>
            ) : (
              <span
                title={"Mở khóa user"}
                className={"col-6"}
                style={{ color: "#008000", cursor: "pointer" }}
              >
                <Popconfirm
                  title="Xác nhận mở khóa user"
                  onConfirm={() => onLock_Unlock(record)}
                  okText="Mở khóa"
                >
                  <UnlockOutlined style={{ color: "#008000" }} />
                </Popconfirm>
              </span>
            )}
          </Col>
          {userInfo.is_superuser === true && (
            <Col span={8}>
              <span
                title={"Đặt lại mật khẩu"}
                className={"col-6"}
                style={{ color: "red", cursor: "pointer" }}
              >
                <Popconfirm
                  title="Xác nhận Reset. (Chức năng này chỉ hiện với Admin/Superuser, chỉ reset DB hr-v2)"
                  onConfirm={() => resetPass(record.id)}
                  okText="Gửi"
                >
                  <RedoOutlined style={{ color: "#ff4d4f" }} />
                </Popconfirm>
              </span>
            </Col>
          )}
        </Row>
      </>
    );
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center",
      render: (value, item, index) =>
        ((pager.current || 1) - 1) * pager.pageSize + index + 1,
      sortDirections: ["descend", "ascend", "descend"],
      ellipsis: true,
      width: 50,
      fixed: "left",
    },
    {
      title: "MSNV",
      dataIndex: "msnv",
      key: "msnv",
      filterKey: "msnv",
      align: "center",
      type: "text",
      canSearch: true,
      width: 100,
      fixed: "left",
      // render: name => name
    },
    {
      title: "Họ tên",
      dataIndex: "hoTen",
      key: "hoTen",
      filterKey: "hoTen",
      align: "center",
      type: "text",
      canSearch: true,
      fixed: "left",
      width: 170,
      render: (value, record) =>
        record.ho != "" ? record.ho + " " + record.ten : record.ten,
    },
    {
      title: "Tên đăng nhập",
      dataIndex: "username",
      key: "username",
      filterKey: "username",
      width: 150,
      align: "center",
      type: "text",
      canSearch: true,
    },
    {
      title: "Chức vụ",
      dataIndex: "chucVu",
      key: "chucVu",
      filterKey: "chucVu",
      width: 160,
      align: "center",
      type: "text",
      canSearch: true,
    },
    {
      title: "Bộ phận",
      dataIndex: "boPhan",
      key: "boPhan",
      filterKey: "boPhan",
      width: 160,
      align: "center",
      type: "text",
      canSearch: true,
    },
    {
      title: "Team",
      dataIndex: "team",
      key: "team",
      filterKey: "team",
      width: 160,
      align: "center",
      type: "text",
      canSearch: true,
    },
    {
      title: "Loại người dùng",
      dataIndex: "loaiND",
      key: "loaiND",
      filterKey: "loaiND",
      width: 160,
      align: "center",
      type: "text",
      canSearch: true,
    },
    {
      title: "Loại nhân viên",
      dataIndex: "loaiNV",
      key: "loaiNV",
      filterKey: "loaiNV",
      width: 160,
      align: "center",
      type: "text",
      canSearch: true,
    },
    {
      title: "Ngày tạo",
      dataIndex: "ngayTao",
      key: "ngayTao",
      filterKey: "ngayTao",
      width: 160,
      align: "center",
      type: "text",
      canSearch: true,
      render: (value, record) => moment(value).format("L HH:mm"),
    },
    {
      title: "Trạng thái",
      dataIndex: "isActive",
      key: "isActive",
      filterKey: "isActive",
      width: 100,
      align: "center",
      type: "text",
      canSearch: true,
      render: (value, record) =>
        value === true ? (
          <CheckCircleOutlined
            style={{ color: "#008000" }}
            title="Đang hoạt động"
          />
        ) : (
          <CloseCircleOutlined
            style={{ color: "#ff4d4f" }}
            title="Không hoạt động"
          />
        ),
    },
    {
      title: "Thao tác",
      dataIndex: "",
      key: "",
      filterKey: "",
      width: 100,
      align: "center",
      type: "text",
      canSearch: true,
      fixed: "right",
      render: (text, record) => getButtonChangeStatus(record),
    },
  ];

  const handleChange = (pagination) => {
    const currentPager = { ...pager };
    currentPager.current = pagination.current;
    currentPager.pageSize = pagination.pageSize;
    setPager({ ...currentPager });
    fetchData({
      status: currentPager.status,
      page_size: pagination.pageSize,
      page: pagination.current,
      search,
    });
  };

  // const onQuickChangeYear=(type)=>{
  //     let yearChange;
  //     if (type === 'previous'){
  //         yearChange = moment(currentSelectedDate).subtract(1, 'year');
  //     } else {
  //         yearChange = moment(currentSelectedDate).add(1, 'year');
  //     }
  //     setCurrentSelectedDate(yearChange);
  //     fetchData();
  // }

  // const onChangeYear =(date)=>{
  //     // setIsCreate(false)
  //     setCurrentSelectedDate(date);
  //     fetchData();
  //     // const lsDateTemp = getDateRange(date);
  //     // setLsDate(lsDateTemp);
  // };

  const handleChangeUpload = ({ fileList }) => {
    setFileExcelDataStaff(fileList);
    if (fileList.length != 0) {
      var FormData = require("form-data");
      var data = new FormData();
      if (fileList != undefined) {
        fileList.forEach((element) => {
          data.append("fileupload", element.originFileObj);
        });
      }
      UploadTempStaffApi(data)
        .then((res) => {
          if (res.data.message != "success") {
            openNotificationWithIcon("error", "Lỗi", res.data.message);
          } else {
            openNotificationWithIcon(
              "success",
              "Thành công",
              "Thêm dữ liệu thành công, vui lòng kiểm tra lại danh sách nhân viên."
            );
            fetchData({ page: 1, page_size: pager.pageSize, search });
          }
          setFileExcelDataStaff([]);
        })
        .catch((err) => {
          setFileExcelDataStaff([]);
          openNotificationWithIcon(
            "error",
            "Không nhập được file yêu cầu. Bạn vui lòng thử lại."
          );
        });
    }
  };

  useEffect(() => {
    const id = setInterval(() => {
      fetchData({ page: 1, page_size: pager.pageSize, search });
      // setPager({pageSize: defaultPageSize,current: 1});
      clearInterval(id);
    }, 300);
    return () => clearInterval(id);
  }, [search]);

  const onSearch = (e) => {
    const search = e.target.value;
    setSearch(search);
  };

  const fileDownload_Staff = () => {
    setLoading_page(true);
    const fnFileDownload = require("js-file-download");
    const filename =
      "DanhSachNhanVien_" +
      moment(currentSelectedDate).format("DDMMYYYY") +
      ".xlsx";
    var options = {
      headers: {
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    };
    DownloadStaffApi()
      .then((res) => {
        fnFileDownload(res.data, filename, options);
        setLoading_page(false);
      })
      .catch((err) => {
        console.log(err);
        openNotificationWithIcon(
          "error",
          "Không tải được danh sách nhân viên. Bạn vui lòng thử lại."
        );
        setLoading_page(false);
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Danh sách nhân viên</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="#">Cấu hình</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/cau-hinh/cau-hinh-he-thong">
                    Cấu hình hệ thống
                  </Link>
                </li>
                <li className="breadcrumb-item active">Danh sách nhân viên</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div
          className={
            "col-12 mb-2 d-sm-flex align-items-center justify-content-between"
          }
        >
          <Row
            gutter={[8, 8]}
            style={{ flexDirection: "row-reverse", float: "right" }}
          >
            <Col>
              <Button
                ghost
                type="success"
                className={"m-2"}
                onClick={() => setIsShowAddStaff(true)}
                icon={<PlusCircleOutlined />}
              >
                Thêm mới
              </Button>
              <Button
                type={"danger"}
                className={"m-2 btnGreen"}
                style={{ marginRight: 5 }}
                onClick={fileDownload_Staff}
                icon={<DownloadOutlined />}
              >
                Danh sách nhân viên
              </Button>
              <Upload
                accept=".xlsx"
                onChange={handleChangeUpload}
                fileList={fileExcelDataStaff}
                maxCount={1}
                className={"styleUploadExcel"}
                beforeUpload={(file) => {
                  return false;
                  // if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                  //     messageBox('error','Lỗi', `Sai định dạng file. Chỉ chấp nhận: EXCEL (.xlsx).`)
                  //     return Upload.LIST_IGNORE;
                  // }
                  // return file.type === 'image/png' ? true : Upload.LIST_IGNORE;
                }}
              >
                <Button danger type="dashed" htmlType="button">
                  Tải lên danh sách
                </Button>
              </Upload>
            </Col>
          </Row>

          <Row gutter={[8, 8]} style={{ flexDirection: "row-reverse" }}>
            <Col>
              <Search
                placeholder="Nhập từ khóa tìm kiếm"
                size="normal"
                onChange={onSearch}
                loading={false}
              />
            </Col>
          </Row>
          {/* <Button ghost type='success' className={'m-2'} onClick={()=>fileDownload} icon={<DownloadOutlined />} >Tải file mẫu</Button> */}
          {/* <Upload
                            accept=".xlsx"
                            onChange={handleChangeUpload}
                            fileList={fileExcelUpload}
                            maxCount={1}
                            className="styleUpload"
                            beforeUpload={ file => {
                                // if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                                //     messageBox('error','Lỗi', `Sai định dạng file. Chỉ chấp nhận: EXCEL (.xlsx).`)
                                //     return Upload.LIST_IGNORE;
                                // }
                                return false;
                                // return file.type === 'image/png' ? true : Upload.LIST_IGNORE;
                            }
                        }
                        >
                            <Button ghost type='success' className={'m-2'}  icon={<UploadOutlined />} loading={uploading} >Nhập file</Button>
                        </Upload> */}
        </div>
      </div>
      <Spin spinning={loading_page}>
        <div className="row">
          <Table
            dataSource={data}
            columns={columns}
            loading={loading}
            className={"custom-table-hover style-6"}
            bordered={true}
            scroll={data.length > 0 && { x: 1920, y: 500 }}
            size={"small"}
            // scroll={{x:800}}
            // className
            rowClassName={"styleTableLeTet"}
            // size={'small'}
            rowKey="id"
            onChange={handleChange}
            pagination={{
              current: pager.current,
              pageSize: pager.pageSize,
              total: pager.count,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "15", "25", "50"],
            }}
          />
        </div>
      </Spin>

      <ModalAddStaff
        visible={isShowAddStaff}
        onCancel={() => setIsShowAddStaff(false)}
        fetchData={fetchData}
        search={search}
        pager={pager}
        currentDate={currentSelectedDate}
        lsTeam={lsTeam}
        lsChucVu={lsChucVu}
        lsLoaiND={lsLoaiND}
        lsLoaiNhanVien={lsLoaiNhanVien}
        lsLoaiCC={lsLoaiCC}
      />
      <ModalEditStaff
        visible={isShowEditStaff}
        onCancel={() => setIsShowEditStaff(false)}
        fetchData={fetchData}
        search={search}
        pager={pager}
        currentDate={currentSelectedDate}
        lsTeam={lsTeam}
        dataInforUser={dataInforUser}
        lsChucVu={lsChucVu}
        lsLoaiND={lsLoaiND}
        lsLoaiNhanVien={lsLoaiNhanVien}
        lsLoaiCC={lsLoaiCC}
      />
      <ModalRoleUser
        visible={isShowRole}
        onCancel={() => setIsShowRole(false)}
        fetchData={fetchData}
        search={search}
        pager={pager}
        currentDate={currentSelectedDate}
        lsTeam={lsTeam}
        dataInforUser={dataInforUser}
        lsQuyen={lsQuyen}
        lsGroupRole={lsGroupRole}
      />
    </>
  );
};
